if (import.meta.hot) {
	import.meta.hot.accept();
}

import { loadApp, loadModule } from '@spon/core';
import 'lazysizes';

// import Header from '@/globals/Header';
import SetVh from '@/globals/SetVh';

import '@/plugins/logger';
import webfontloader from '@/plugins/webfontloader';
import detectTab from '@/utils/detectTab';
import activeLinks from '@/utils/activeLinks';
import localLinks from '@/utils/localLinks';

webfontloader();

// load from data-behaviours
const app = loadApp(name => import(`./behaviours/${name}.js`), document.body); // eslint-disable-line

// This was being called twice; moved to /behaviours/ and added as data-attr.
// loadModule({
// 	module: Header,
// 	id: 'header',
// 	node: document.getElementById('header'),
// 	// keepAlive: true,
// });

loadModule({
	module: SetVh,
	id: 'set-vh',
	node: document.body,
	// keepAlive: true,
});

detectTab();
activeLinks(window.location.pathname);
localLinks();
